var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('headerBox',{attrs:{"payformline":_vm.$store.state.user.formInline},on:{"tabsSkip":_vm.tabsSkip}}),_c(_vm.tabCom,{tag:"div",staticClass:"contentBox",attrs:{"payformline":_vm.$store.state.user.formInline}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }